import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(firstName: string, lastName: string, username: string, oldPassword: string): ValidatorFn {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-=<>?])[A-Za-z\d!@#$%^&*()_\-=<>?]{8,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value;

    const lowerFirstName = firstName ? firstName.toLowerCase() : '';
    const lowerLastName = lastName ? lastName.toLowerCase() : '';
    const lowerUsername = username ? username.toLowerCase() : '';
    const lowerPassword = password ? password.toLowerCase() : '';
    const usernamePart = lowerUsername.includes('@') ? lowerUsername.split('@')[0] : lowerUsername;

    // Check if the new password is the same as the old password
    if (password && password === oldPassword) {
      console.log('passwordMatch: New password cannot be the same as the old password.');
      return { passwordMatch: 'New password cannot be the same as the old password.' };
    }

    console.log(lowerFirstName, lowerLastName, usernamePart, lowerPassword);
    // Check if password meets the regex complexity
    if (password && !passwordRegex.test(password)) {
      console.log(
        password,
        'passwordComplexity: The password doesnt meet the specified minimum complexity requirements. Please correct and submit again.'
      );
      return {
        passwordComplexity: "The password doesn't meet the specified minimum complexity requirements. Please correct and submit again.",
      };
    }

    // Check if the password contains user's personal details
    if (
      (lowerFirstName && lowerPassword.includes(lowerFirstName)) ||
      (lowerLastName && lowerPassword.includes(lowerLastName)) ||
      (usernamePart && lowerPassword.includes(usernamePart))
    ) {
      console.log('passwordPersonalDetails: The password cannot contain your personal details.');
      return {
        passwordComplexity: "The password doesn't meet the specified minimum complexity requirements. Please correct and submit again.",
      };
    }

    // If no issues, return null (valid password)
    return null;
  };
}
